// extracted by mini-css-extract-plugin
export default {"icon":"YW1ta","more":"rFFrE","actions":"iL1B5"};